import React, {PureComponent} from "react";
import {FiltersEntity} from "../data/entities/FiltersEntity";
import FilterGameName from "./FilterGameName";
import {Badge, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import classNames from 'classnames';

interface Props {
    filters: FiltersEntity;
    brands: string[];
    displayMode: "list" | "grid";
    order: "name" | "launch date";
    setNameFilter: Function;
    toggleBrandFilter: Function;
    setOrder: (value: "name" | "launch date") => void;
    setDisplayMode: (value: "list" | "grid") => void;
}

export default class GamesFilters extends PureComponent<Props> {
    render(): JSX.Element {
        let toggleListDisplayStyle = classNames({
            "material-icons": true,
            "view-list": true,
            "active": this.props.displayMode === "list"
        });

        let toggleGridDisplayStyle = classNames({
            "material-icons": true,
            "view-module": true,
            "display-toggle": true,
            "active": this.props.displayMode === "grid"
        });

        return (
            <nav className="filters">
                <div className="filters-left">
                    <FilterGameName value={this.props.filters.name} onChange={this.props.setNameFilter}/>

                    <div className="filter-dropdowns py-4">
                        <UncontrolledDropdown>
                            <DropdownToggle nav caret>
                                {this.props.filters.brand.length > 0 && <Badge pill>{this.props.filters.brand.length}</Badge>}
                                <FormattedMessage id="filters.brand"/>
                            </DropdownToggle>
                            <DropdownMenu right className="checkbox-filter" flip={false}>
                                <DropdownItem toggle={false} onClick={() => this.props.toggleBrandFilter("ALL")}>
                                    {this.props.filters.brand.length === 0 && <FontAwesomeIcon icon="check-circle"/>}
                                    <FormattedMessage id="filters.show_all"/>
                                </DropdownItem>
                                {
                                    this.props.brands.map((brand, index) => {
                                        return (
                                            <DropdownItem key={index} toggle={false} onClick={() => this.props.toggleBrandFilter(brand)}>
                                                {this.props.filters.brand.includes(brand) && <FontAwesomeIcon icon="check-circle"/>}
                                                {brand}
                                            </DropdownItem>
                                        );
                                    })
                                }
                            </DropdownMenu>
                        </UncontrolledDropdown>

                        <UncontrolledDropdown>
                            <DropdownToggle nav caret>
                                <FormattedMessage id="filters.sort"/>
                            </DropdownToggle>
                            <DropdownMenu right className="checkbox-filter" flip={false}>
                                <DropdownItem onClick={() => this.props.setOrder("launch date")}>
                                    {this.props.order === "launch date" && <FontAwesomeIcon icon="check-circle"/>}
                                    <FormattedMessage id="filters.release_date"/>
                                </DropdownItem>
                                <DropdownItem onClick={() => this.props.setOrder("name")}>
                                    {this.props.order === "name" && <FontAwesomeIcon icon="check-circle"/>}
                                    <FormattedMessage id="filters.game_name"/>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </div>

                <div className="filters-right py-4">
                    <div className="display-style">
                        <span onClick={() => this.props.setDisplayMode("grid")}>
                            <FontAwesomeIcon icon="th-large" className={toggleGridDisplayStyle}/>
                        </span>
                        <span onClick={() => this.props.setDisplayMode("list")}>
                            <FontAwesomeIcon icon="list" className={toggleListDisplayStyle}/>
                        </span>
                    </div>
                </div>
            </nav>
        );
    }
}